import { type FC, memo, useMemo } from "react";
import { Dropdown, type MenuProps } from "antd";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CREATE_LIST_ROUTE = "/account/engagement/create-list";
const CREATE_SEGMENT_ROUTE = "/account/engagement/create-segment";

interface CreateMenuOptionProps {
  title: string;
  description: string;
}

const CreateMenuOption: FC<CreateMenuOptionProps> = ({ title, description }) => (
  <div className="audience-create-menu__option">
    <span className="audience-create-menu__title">{title}</span>
    <span className="audience-create-menu__description">{description}</span>
  </div>
);

const AudienceCreateMenu: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const items = useMemo<MenuProps["items"]>(
    () => [
      {
        key: "list",
        label: (
          <CreateMenuOption
            title={t("audienceOverview.createListTitle")}
            description={t("audienceOverview.createListDescription")}
          />
        ),
        onClick: () => navigate(CREATE_LIST_ROUTE),
      },
      {
        key: "segment",
        label: (
          <CreateMenuOption
            title={t("audienceOverview.createSegmentTitle")}
            description={t("audienceOverview.createSegmentDescription")}
          />
        ),
        onClick: () => navigate(CREATE_SEGMENT_ROUTE),
      },
    ],
    [t, navigate],
  );

  return (
    <Dropdown
      menu={{ items }}
      trigger={["click"]}
      placement="bottomRight"
      overlayClassName="audience-create-menu"
    >
      <button type="button" className="button button--primary audience-overview__create-btn">
        <Plus size={16} aria-hidden />
        {t("audienceOverview.createListSegment")}
      </button>
    </Dropdown>
  );
};

export default memo(AudienceCreateMenu);
